<div class="reset-pin-component">
    <template v-if="isLinkExpired">
        <CounterInformation @time-ended="redirectToLogin" />
    </template>

    <template v-else>
        <form
            class="reset-pin-email"
            v-if="!resetCode && !phoneMask"
            @submit.prevent="onSubmitEmail"
        >
            <h1>{{ $t("reset-pin.header") }}</h1>
            <div class="info-text">{{ $t("sign-in.enter-email") }}</div>
            <input
                class="sign-in-email form-input rounded"
                required
                v-model="email"
                type="email"
                autocapitalize="none"
                autocomplete="email"
                :placeholder="$t('sign-in.email-placeholder')"
                autofocus="autofocus"
            />
            <button class="bnr-button red form-button" type="submit">
                {{ $t("reset-pin.submit-email") }}
            </button>
        </form>

        <form
            class="reset-pin-new-pin"
            v-if="!!resetCode && !phoneMask"
            @submit.prevent="submitNewPin"
        >
            <div>
                <div class="info-text">{{ $t("reset-pin.new-pin") }}</div>
                <PinCodeComponent
                    :length="getRequiredPinLength"
                    placeholder=""
                    @input="onNewPinCodeInput"
                />
            </div>

            <div>
                <div class="info-text">
                    {{ $t("reset-pin.repeat-new-pin") }}
                </div>
                <PinCodeComponent
                    ref="repeatPinComponent"
                    :autofocus="false"
                    :length="getRequiredPinLength"
                    placeholder=""
                    @input="onRepeatNewPinCodeInput"
                />
            </div>
            <button class="bnr-button form-button red" type="submit">
                {{ $t("reset-pin.submit-new-pin") }}
            </button>
        </form>

        <VerifySmsComponent
            v-if="phoneMask"
            :email="email"
            :pin="newPin"
            :phone-mask="phoneMask"
        >
        </VerifySmsComponent>

        <div v-show="showLoadingSpinner" class="spinner"></div>
        <div class="result-text" v-if="emailSent && !resetCode">
            {{ emailResult }}
        </div>
    </template>
</div>
